/* eslint-disable func-names */
import moment, { Moment } from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectOverviewFilter, selectOverviewFilterType } from 'Selector/SRISelector';
import styled from 'styled-components';
import { actions as SRIActions } from 'Slice/SRISlice';
import { SRIFilters } from 'Types/SRITypes';
import { selectUserCreationDate } from 'Selector/GlobalSearchContentSelector';
import SRIDateRangePicker from './SRIDateRangePicker';

const FilterRowWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 0px;
  width: 100%;
`;

const FilterHeadInput = styled.div`
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

type Props = {
  iconMode?: boolean;
};

const defaultProps = {
  iconMode: false,
};

type DateFilterLabelObject = {
  start: Moment;
  end: Moment;
  label?: string;
  allTime?: boolean
};

const processRanges = (userCreationDate: string) => {
  const getRanges = (creationDate: string): { [key: string]: () => Moment[] } => ({
    'All Time': () => [moment(creationDate, 'YYYY-MM-DD h:mm:ss'), moment()],
    'This Month': () => [moment().startOf('month'), moment()],
    'Last 3 months': () => [moment().subtract(2, 'month').startOf('month'), moment()],
    'Last 6 months': () => [moment().subtract(5, 'month').startOf('month'), moment()],
    'Last 12 months': () => [moment().subtract(11, 'month').startOf('month'), moment()],
  });

  return Object.fromEntries(
    Object.entries(getRanges(userCreationDate))
      .map(([key, getRange]) => [key, getRange()]),
  );
};

const SRIDropdownFilter = function ({ iconMode }: Props) {
  const filtersType: string = useSelector(selectOverviewFilterType);
  const SRIfilters: SRIFilters = useSelector(selectOverviewFilter);
  const userCreationDate = useSelector(selectUserCreationDate);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [filters, setFilters] = useState<DateFilterLabelObject | null>(null);
  // const [filters, setFilters] = useState<DateFilterLabelObject>({
  //   start: moment(),
  //   end: moment(),
  //   label: filtersType,
  //   allTime: filtersType === 'All Time',
  // });

  const dispatch = useDispatch();

  const handleSelectFilter = useCallback((start: Moment, end: Moment, label?: string) => {
    if (label === 'This Month' || label === 'Last 3 months' || label === 'Last 6 months' || label === 'Last 12 months' || label === 'All Time') {
      const filterObject = {
        start_date: label === 'All Time' && userCreationDate ? moment(userCreationDate).format('YYYY-MM-DD HH:mm:ss') : start.format('YYYY-MM-DD HH:mm:ss'),
        end_date: end.format('YYYY-MM-DD HH:mm:ss'),
        type: label || filtersType,
        allTime: label === 'All Time',
      };
      setFilters({
        start: label === 'All Time' && userCreationDate ? moment(userCreationDate) : start, end, label, allTime: label === 'All Time',
      });
      dispatch(SRIActions.setFilters(filterObject));
    }
  }, [filtersType, userCreationDate]);

  useEffect(() => {
    if (userCreationDate) {
      const ranges = processRanges(userCreationDate);
      const [start, end] = ranges['Last 3 months'];
      setFilters({
        start,
        end,
        label: 'Last 3 months',
        allTime: false,
      });
      if (!iconMode) {
        handleSelectFilter(start, end, 'Last 3 months');
      }
    }
  }, [userCreationDate, iconMode]);

  useEffect(() => {
    setIsFilterActive(filters?.label !== 'Last 3 months');
  }, [filters]);

  useEffect(() => {
    if (SRIfilters.start_date && SRIfilters.end_date && userCreationDate) {
      const ranges = processRanges(userCreationDate);
      if (filtersType === 'Custom Range') {
        setFilters({
          start: moment(SRIfilters.start_date),
          end: moment(SRIfilters.end_date),
          label: filtersType,
        });
      } else if (filtersType && ranges[filtersType]) {
        const [start, end] = ranges[filtersType];
        setFilters({
          start, end, label: filtersType, allTime: filtersType === 'All Time',
        });
      }
    }
  }, [SRIfilters, filtersType, userCreationDate]);

  if (!filters || !userCreationDate) {
    return null; // or a loading indicator
  }

  return (
    <FilterRowWrap>
      <FilterHeadInput>
        {/* {filters.start && filters.end && ( */}
        <SRIDateRangePicker
          ranges={processRanges(userCreationDate)}
          label={filters.label}
          filters={filters}
          onDateChange={handleSelectFilter}
          isActive={isFilterActive}
        />
        {/* )} */}
      </FilterHeadInput>
    </FilterRowWrap>
  );
};

SRIDropdownFilter.defaultProps = defaultProps;
export default SRIDropdownFilter;
